import { Layout } from './layout';

Layout.displayName = 'RootComponent';

export { Layout as RootComponent };

export type { Props as RootComponentProps } from './types';
